import React from 'react';
import MaterialIcon from "./MaterialIcon.jsx";

const VerticalDots = React.forwardRef(
	function VerticalDots({ ...props }, ref) {

		return (
			<MaterialIcon
				ref={ref}
				{...props}
			>
				more_vert
			</MaterialIcon>
		);
	}
);

export default VerticalDots;